import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";


import styles from "assets/jss/material-kit-react/views/componentsSections/bannersStyle.js";

const useStyles = makeStyles(styles);

export default function SectionBanners(props) {
  const classes = useStyles();
  var image =  props.image;
  return (
    <div >
      <div
          className={classes.banner}
          style={{ backgroundImage: "url(" + image + ")" }}
        >
        </div>
      
    </div>
  );
}
